export default __webpack_public_path__ + "static/media/clarissa.f9f106ef.jpg";